import { DoctorInterface } from 'src/interfaces/doctor'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type State = {
  loading: boolean
  entity: DoctorInterface | null
}

const initialState: State = {
  loading: false,
  entity: null,
}

const { actions, reducer } = createSlice({
  // TODO: remember change the name of store
  name: 'first_doctor',
  initialState,
  reducers: {
    updateEntity: (state, action: PayloadAction<DoctorInterface>) => {
      state.entity = action.payload
    },
    updateLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
  },
})

export { reducer }
export default actions
